// Generated by BUCKLESCRIPT VERSION 2.2.3, PLEASE EDIT WITH CARE
'use strict';

var Css = require("bs-css/lib/js/src/Css.js");
var Link = require("./link");
var $$Array = require("bs-platform/lib/js/array.js");
var Theme = require("./theme");
var React = require("react");
var Storage = require("./storage");
var Caml_int32 = require("bs-platform/lib/js/caml_int32.js");
var Caml_format = require("bs-platform/lib/js/caml_format.js");
var ReasonReact = require("reason-react/lib/js/src/ReasonReact.js");

var card = Css.style(/* :: */[
      Css.display(Css.flexBox),
      /* :: */[
        Css.fontSize(Theme.standardFontSize),
        /* [] */0
      ]
    ]);

var dashboard = Css.style(/* :: */[
      Css.textAlign(Css.center),
      /* :: */[
        Css.display(Css.flexBox),
        /* :: */[
          Css.flexDirection(Css.column),
          /* :: */[
            Css.alignItems(Css.center),
            /* [] */0
          ]
        ]
      ]
    ]);

var flexList = Css.style(/* :: */[
      Css.textAlign(Css.center),
      /* :: */[
        Css.display(Css.flexBox),
        /* :: */[
          Css.flexDirection(Css.column),
          /* :: */[
            Css.alignItems(Css.center),
            /* [] */0
          ]
        ]
      ]
    ]);

var inputHeader = Css.style(/* :: */[
      Css.marginBottom(Css.px(0)),
      /* :: */[
        Css.fontWeight(700),
        /* [] */0
      ]
    ]);

var inputField = Css.style(/* :: */[
      Css.margin4(Css.px(10), Css.px(0), Css.px(10), Css.px(0)),
      /* :: */[
        Css.padding2(Css.px(5), Css.px(5)),
        /* [] */0
      ]
    ]);

var someLink = Css.style(/* :: */[
      Css.fontSize(Theme.smallFontSize),
      /* :: */[
        Css.cursor(/* pointer */-786317123),
        /* :: */[
          Css.margin2(Css.px(5), Css.px(0)),
          /* [] */0
        ]
      ]
    ]);

var Styles = /* module */[
  /* card */card,
  /* dashboard */dashboard,
  /* flexList */flexList,
  /* inputHeader */inputHeader,
  /* inputField */inputField,
  /* someLink */someLink
];

function text(prim) {
  return prim;
}

var component = ReasonReact.reducerComponent("FoodWeek");

function make(week, _) {
  var newrecord = component.slice();
  newrecord[/* didMount */4] = (function () {
      return /* NoUpdate */0;
    });
  newrecord[/* render */9] = (function (self) {
      return React.createElement("div", {
                  className: dashboard
                }, React.createElement("div", {
                      className: flexList
                    }, React.createElement("h1", undefined, "Mahlzeiten Woche " + week), React.createElement("p", undefined, "current week: " + String(self[/* state */2][/* week */0])), $$Array.map((function (param) {
                            var day = param[1];
                            var el = param[0];
                            return React.createElement("button", {
                                        key: el,
                                        className: Theme.simpleButton(/* () */0),
                                        onClick: (function () {
                                            return ReasonReact.Router[/* push */0]("/foodday/" + String(day + Caml_int32.imul(Caml_format.caml_int_of_string(week) - 1 | 0, 7) | 0));
                                          })
                                      }, "Mahlzeiten Tag " + (String(el) + ""));
                          }), /* array */[
                          /* tuple */[
                            "1",
                            1
                          ],
                          /* tuple */[
                            "2",
                            2
                          ],
                          /* tuple */[
                            "3",
                            3
                          ],
                          /* tuple */[
                            "4",
                            4
                          ],
                          /* tuple */[
                            "5",
                            5
                          ],
                          /* tuple */[
                            "6",
                            6
                          ],
                          /* tuple */[
                            "7",
                            7
                          ]
                        ])), ReasonReact.element(/* None */0, /* None */0, Link.make("/dashboard", "Dashboard", someLink, /* array */[])));
    });
  newrecord[/* initialState */10] = (function () {
      return /* record */[
              /* week */Storage.weekOfDay(/* () */0),
              /* day */Storage.weekDay(/* () */0)
            ];
    });
  newrecord[/* reducer */12] = (function (_, _$1) {
      return /* NoUpdate */0;
    });
  return newrecord;
}

exports.Styles = Styles;
exports.text = text;
exports.component = component;
exports.make = make;
/* card Not a pure module */



//////////////////
// WEBPACK FOOTER
// ./src/foodWeek.re
// module id = 127
// module chunks = 0